import CustomizationNode from './CustomizationNode';

export default class CustomizationImage extends CustomizationNode {
  static type = 'customizationImages';

  url: string;

  image: string;

  label(){
    return 'Immagine'
  }
}
